import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { ProtectedRoute, TokenVerificationHandler } from '../components/auth';
import {
  HomePage,
  AuthPage,
  RankingPage,
  UniversityDetailPage,
  AboutPage,
  NotFoundPage
} from '../pages';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        {/* Routes publiques */}
        <Route path="auth" element={<AuthPage />} />
        <Route path="auth/verify" element={<TokenVerificationHandler />} />
        <Route path="a-propos" element={<AboutPage />} />
        
        {/* Routes qui nécessitent une authentification */}
        <Route 
          index 
          element={
            <ProtectedRoute redirectTo="/auth">
              <HomePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="classement" 
          element={
            <ProtectedRoute redirectTo="/auth">
              <RankingPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="universites/:id" 
          element={
            <ProtectedRoute redirectTo="/auth">
              <UniversityDetailPage />
            </ProtectedRoute>
          } 
        />
        
        {/* Route 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};
